import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-screen bg-back-drop bg-no-repeat bg-customVeryLightGrayishBlue", { 'bg-customVeryDarkGrayishBlue': _ctx.isDarkThemeOn }])
  }, [
    _createVNode(_component_router_view)
  ], 2))
}